import { Star, Target, Users, ShieldCheck } from "lucide-react";

const values = [
  {
    icon: Target,
    title: "Mission-First Discipline",
    desc: "Every engagement is run like an operation — clear objectives, defined rules of engagement, measurable outcomes.",
  },
  {
    icon: ShieldCheck,
    title: "Tested Under Pressure",
    desc: "Our team has operated in environments where failure was not an option. We bring that standard to your stack.",
  },
  {
    icon: Users,
    title: "Veteran-Led, Always",
    desc: "Proudly veteran-owned and operated. We hire and mentor those who've served, building a team you can trust.",
  },
];

export const Veteran = () => {
  return (
    <section
      id="veteran"
      data-testid="veteran-section"
      className="relative py-24 md:py-32 bg-[#05070A] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-2 border border-[#00FFA3]/40 bg-[#00FFA3]/5 px-4 py-2 mb-8">
            <Star size={14} strokeWidth={1.5} className="text-[#00FFA3]" />
            <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#00FFA3]">
              Veteran-Owned & Operated
            </span>
          </div>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white leading-tight">
            Disciplined.
            <br />
            Tested. <span className="text-[#00FFA3]">Proven.</span>
          </h2>
          <p className="text-slate-400 mt-6 text-lg leading-relaxed">
            CyberVets was founded on a simple belief: the discipline, integrity,
            and situational awareness forged in military service translate
            directly into world-class cyber defense. We don't just protect
            systems — we stand watch.
          </p>

          <div className="mt-10 space-y-6">
            {values.map((v) => (
              <div
                key={v.title}
                data-testid={`value-${v.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="flex gap-4"
              >
                <div className="shrink-0 w-11 h-11 flex items-center justify-center border border-white/10 bg-[#151921]">
                  <v.icon size={20} strokeWidth={1.5} className="text-[#00FFA3]" />
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg text-white">
                    {v.title}
                  </h3>
                  <p className="text-slate-400 text-sm mt-1 leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-0.5 bg-gradient-to-br from-[#00FFA3]/30 to-[#00E5FF]/10 blur-sm" />
          <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1680992044138-ce4864c2b962"
              alt="Secure cloud server infrastructure"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#05070A] via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#00FFA3]">
                Operational Readiness
              </div>
              <div className="font-heading font-bold text-2xl text-white mt-2">
                Standing watch over your infrastructure 24/7/365.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
